var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/stack/x-stack.ts
import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";
import { ChemistryLitElement } from "../../../chemistry-lit-element.js";
import { acss } from "../../../directives/acss.js";
import { css } from "../../../directives/css.js";
import { xComponents } from "../../x-components.js";
import "../x-button.js";
import "./x-stack-button";
import { XStackButton } from "./x-stack-button.js";
var toggleStuff = (path, openStack) => {
  for (const pathElement of path) {
    const siblings = [];
    const getSiblingsRecursively = (node, mode) => {
      if (!node)
        return;
      const sibling = { previous: node.previousSibling, next: node.nextSibling }[mode];
      if (!sibling || sibling instanceof XStackBreadcrumb)
        return;
      siblings.push(sibling);
      getSiblingsRecursively(sibling, mode);
    };
    getSiblingsRecursively(pathElement.previousSibling, "previous");
    getSiblingsRecursively(pathElement.nextSibling, "next");
    for (const sibling of siblings) {
      try {
        sibling.style.display = openStack ? "none" : "";
      } catch {
      }
    }
    if (pathElement instanceof StackItem) {
      pathElement.isOpen = openStack;
    }
  }
};
var XStack = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this._path = [];
    this._breadcrumbs = createRef();
  }
  setPath(path) {
    toggleStuff(this._path, false);
    toggleStuff(path, true);
    this._path = path;
    this._breadcrumbs.value.path = path;
    this._breadcrumbs.value.requestUpdate();
  }
  render() {
    return xComponents(
      html`
        <x-flex space="md">
          <x-stack-breadcrumb
            .path=${this._path}
            ${ref(this._breadcrumbs)}
            @jump-to-path-index=${(e) => {
        toggleStuff(this._path, false);
        this._path.splice(e.detail.value + 1, this._path.length);
        this.setPath(this._path);
      }}
          ></x-stack-breadcrumb>
          ${this.renderContent()}
        </x-flex>
      `
    );
  }
  renderContent() {
    return html` <slot></slot> `;
  }
};
__decorateClass([
  property({ attribute: false, type: String })
], XStack.prototype, "openStackItemID", 2);
XStack = __decorateClass([
  customElement("x-stack")
], XStack);
var XStackBreadcrumb = class extends ChemistryLitElement {
  render() {
    const path = this.path ?? [];
    const renderables = [];
    renderables.push(
      html`
        <x-icon
          solid
          ${css({ color: this.colors.accent, marginRight: "4px", cursor: "pointer" })}
          @click=${() => this._jumpBackToIndex(-1)}
        >
          house
        </x-icon>
      `
    );
    for (const [index, pathItem] of path.entries()) {
      if (!(pathItem instanceof StackItem))
        continue;
      const isLastItem = index === path.length - 1;
      if (isLastItem) {
        renderables.push(html` <x-text><b> ${pathItem.name} </b></x-text>`);
        continue;
      }
      renderables.push(
        html`
          <x-text
            ${acss({ "&:hover": { textDecoration: "underline" }, cursor: "pointer" })}
            @click=${() => this._jumpBackToIndex(index)}
          >
            ${pathItem.name}
          </x-text>
          <x-text> ● </x-text>
        `
      );
    }
    return xComponents(html`
      <x-flex breadcrumb horizontal crossaxis-center space="xs" ${css({ userSelect: "none" })}> ${renderables} </x-flex>
    `);
  }
  _jumpBackToIndex(index) {
    this.dispatchEvent(new CustomEvent("jump-to-path-index", { detail: { value: index } }));
  }
};
__decorateClass([
  property({ attribute: false })
], XStackBreadcrumb.prototype, "path", 2);
XStackBreadcrumb = __decorateClass([
  customElement("x-stack-breadcrumb")
], XStackBreadcrumb);
var CreateStackItem = ({ name, render }) => {
  return html`
    <stack-item name=${name} .renderContent=${render}>
      <slot></slot>
    </stack-item>
  `;
};
var StackItem = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.name = "Unbenannt";
    this.isOpen = false;
  }
  render() {
    if (this.isOpen)
      return xComponents(html` ${this.renderContent?.() ?? this.renderFallback()} `);
    return this.openStackItemButton();
  }
  renderFallback() {
    return html`
      <div style="padding: 10px; border: 1px solid #ccc; border-radius: 5px; background-color: #f9f9f9;">
        <p style="font-size: 14px; color: #333; margin: 0;">
          Es wurde keine
          <code style="background-color: #e0e0e0; padding: 2px 4px; border-radius: 3px;">renderContent()</code> Funktion
          definiert!
        </p>
        <br />
        <p style="font-size: 14px; color: #333; margin: 0;">
          Nutze <b>wenn möglich</b> die
          <code style="background-color: #e0e0e0; padding: 2px 4px; border-radius: 3px;">CreateStackItem</code>
          Funktion, um ein StackItem zu erstellen.
        </p>
      </div>
    `;
  }
  openStackItemButton() {
    return XStackButton.render({
      name: this.name ?? "Unbenannt",
      onClickCallback: () => this.openItem()
    });
  }
  requestStackUpdate() {
    const resolvedStack = this._resolveStack();
    resolvedStack.stack.requestUpdate();
  }
  openItem() {
    const resolvedStack = this._resolveStack();
    resolvedStack.stack.setPath(resolvedStack.pathToCurrentStackItem);
  }
  _resolveStack() {
    let xStack;
    const getRecursivePath = (start, state2 = []) => {
      let parentElement = start.parentElement;
      if (!parentElement) {
        const parentNode = start.parentNode;
        const parentNodeHost = parentNode.host;
        if (!parentNode || parentNode.nodeType !== 11 || !parentNodeHost || !(parentNodeHost instanceof HTMLElement)) {
          throw new Error("no valid parent found");
        }
        parentElement = parentNodeHost;
      }
      if (parentElement instanceof XStack) {
        xStack = parentElement;
        return state2;
      }
      state2 = [parentElement, ...state2];
      return getRecursivePath(parentElement, state2);
    };
    const pathElements = getRecursivePath(this);
    if (!xStack)
      throw new Error("x-stack node not found");
    pathElements.push(this);
    const resolvedStack = {
      pathToCurrentStackItem: pathElements,
      stack: xStack
    };
    return resolvedStack;
  }
  findNestedStackItems() {
    const foundItems = [];
    let elementCounter = 0;
    const searchRecursively = (element, depth = 0) => {
      elementCounter++;
      const isRootElement = element === this;
      if (!isRootElement && element instanceof Element && element instanceof StackItem) {
        foundItems.push(element);
        return;
      }
      if (element instanceof Element && element.shadowRoot) {
        searchRecursively(element.shadowRoot, depth + 1);
      }
      if (!isRootElement && element instanceof Element && element instanceof StackItem) {
        return;
      }
      const children = Array.from(element instanceof ShadowRoot ? element.children : element.children);
      if (children.length > 0) {
        for (const child of children) {
          searchRecursively(child, depth + 1);
        }
      }
      if (element instanceof Element) {
        const slots = element.querySelectorAll("slot");
        if (slots.length > 0) {
          slots.forEach((slot, index) => {
            const assignedElements = slot.assignedElements();
            assignedElements.forEach((assignedElement) => {
              searchRecursively(assignedElement, depth + 1);
            });
          });
        }
      }
    };
    searchRecursively(this);
    return foundItems;
  }
  // ################################################
  //                    EVENTS
  // ################################################
  // register openCallback and closeCallback
  // trigger events open and close
  willUpdate(_changedProperties) {
    super.willUpdate(_changedProperties);
    if (_changedProperties.has("isOpen") && _changedProperties.get("isOpen") !== void 0 && _changedProperties.get("isOpen") !== this.isOpen) {
      if (this.isOpen)
        this.openCallback();
      else
        this.closeCallback();
    }
  }
  closeCallback() {
    this.dispatchEvent(new CustomEvent("close"));
  }
  openCallback() {
    this.dispatchEvent(new CustomEvent("open"));
  }
};
__decorateClass([
  property({ attribute: true })
], StackItem.prototype, "name", 2);
__decorateClass([
  property({ attribute: false })
], StackItem.prototype, "renderContent", 2);
__decorateClass([
  state()
], StackItem.prototype, "isOpen", 2);
StackItem = __decorateClass([
  customElement("stack-item")
], StackItem);
export {
  CreateStackItem,
  StackItem,
  XStack,
  XStackBreadcrumb
};
